import Meta from "vue-meta";
import Vue from "vue";

Vue.use(Meta, {
  titleTemplate: `%s - ${process.env.VUE_APP_TITLE}`,
});
